import {RejectCashbackRequestModel} from "../../../../models/dashboard/marketplace/marketplaceCashbackRequestModel";
import {adminHttpClient} from "../../../../commons/adminHttpClinet";


const rejectCashbackRequestTransaction = (model:RejectCashbackRequestModel): Promise<any> => {
    return adminHttpClient.put(`/api/Admin/AdminMarketplacePurchase/reject-marketplace-cashback-request`, model)
}
export default rejectCashbackRequestTransaction;